import React, { useState } from 'react';
import { yyyymmdd, isBetweenFromAndToDates, useDebounce } from 'services/Dates';
import { isEmpty } from 'lodash';
import { AAMBeaconControl } from 'components/shared/Beacon';

const DateInputBeacon = ({
  minDate,
  maxDate,
  defaultDate = '',
  onChange,
  onClear = () => { },
  updateDateAlways = false,
  //  customClasses,
  inputFiledClassName,
  id
}) => {
  const [date, setDate] = useState(defaultDate);
  // useEffect with debounce
  useDebounce(() => {
    if (isEmpty(date)) {
      onClear();
      return;
    }

    if (isBetweenFromAndToDates(date, minDate, maxDate) || updateDateAlways) {
      onChange(date);
    }
  }, [date, minDate, maxDate]);

  return (

    <div className="beacon-on-light">
      <AAMBeaconControl >
        <input
          type="date"
          id={id}
          style={inputFiledClassName}
          min={yyyymmdd(minDate)}
          max={yyyymmdd(maxDate)}
          name={'selectedDates'}
          required={true}
          value={date === null ? defaultDate : date}
          onChange={(e) => {
            setDate(e.target.value || '')
          }} />
      </AAMBeaconControl>
    </div>
  );
};

export default DateInputBeacon;
